var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNormalModeSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 16,
    viewBox: "0 0 50 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.68803,
    cy: 7.68803,
    r: 7.68803,
    fill: "#040626"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.6788,
    cy: 7.68803,
    r: 7.68803,
    fill: "#040626"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.6697,
    cy: 7.68803,
    r: 7.68803,
    fill: "#040626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormalModeSymbol);
export default __webpack_public_path__ + "static/media/normal_mode_symbol.83945e62038255fb637c0d003d6675ac.svg";
export { ForwardRef as ReactComponent };